export type ServiceErrorCode =
  | 'link_invalid' // guestCode inexistente (NOT_FOUND del PMS)
  | 'link_expired' // reserva cancelada o enlace caducado
  | 'offline' // sin red
  | 'server' // respuesta no ok o 5xx
  | 'not_supported' // el backend aún no lo soporta (solo mock)
  | 'already_paid' // pagos: el concepto ya estaba pagado al comprobarlo antes de cobrar (app actual)
  | 'payment_failed' // pagos: el PMS no aceptó el cobro (E3 no ok o error HTTP)
  | 'quote_expired' // reserva: la cotización de un cambio ha caducado o el precio ha cambiado
  | 'not_found' // peticiones: la petición no existe (bloque 6)

export class ServiceError extends Error {
  readonly code: ServiceErrorCode
  readonly status: string | number | undefined
  constructor(code: ServiceErrorCode, message?: string, status?: string | number) {
    super(message ?? code)
    this.name = 'ServiceError'
    this.code = code
    this.status = status
  }
}

export function isServiceError(e: unknown): e is ServiceError {
  return e instanceof ServiceError
}

/** Capacidad que la API actual no tiene (D36): siempre el mismo rechazo, que las pantallas muestran como no disponible. */
export const unsupported = <T = never>(): Promise<T> => Promise.reject(new ServiceError('not_supported'))
